<template>
  
  <div class="content content-boxed">

    <div class="row push-50">

    </div>

    <div class="row push-50">

    </div>







    <!-- Full Table -->
      <div class="block">
          <div class="block-header">
              <h3 class="block-title">{{DocumentTableTitle[actualLanguage]}}</h3>
          </div>
          <spinner  size="large" v-if="DocumentListIsReading"></spinner>
          <div v-if="DocumentListIsReading==false" class="block-content">
              <p class="push-30">{{DocumentTableDetail[actualLanguage]}}</p>
              <div class="table-responsive">
                  <table class="table table-striped table-vcenter">
                      <thead>
                          <tr>
                              <th style="width: 30%;">Document</th>
                              <th style="width: 50%;">Description</th>
                              <th class="text-center" style="width: 10%;">Document</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for= "Document in DocumentTableContain">
                              <td class="font-w600">{{Document.Document[actualLanguage]}}</td>
                              <td>{{Document.Detail[actualLanguage]}}</td>
                              <td class="text-center">
                                  <div class="btn-group">
                                      <button class="btn btn-default" type="button" data-toggle="tooltip"
                                      @click="openDocumentInTable(Document.FileLink[actualLanguage])" title="Ouvrir/Open"><i class="fa fa-file-text"></i></button>
                                  </div>
                              </td>
                          </tr>

                      </tbody>
                  </table>
              </div>
          </div>
      </div>
      <!-- END Full Table -->






    <h3 class="h4 font-w600 push-50-t push">{{labelText01[actualLanguage]}}</h3>
    <div class="row">
      <!-- FAQ Dynamique -->
      <div class="block block-themed">
        <div class="block-header bg-primary-dark">
              <ul  class="block-options">
                  <li v-if="flagDisplayAddFaq===0">
                      <button type="button" @click="toggleDisplayAddFaq()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                  </li>
                  <li v-if="flagDisplayAddFaq">
                      <button  type="button" @click="toggleDisplayAddFaq()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                  </li>
              </ul>
          <h2 class="block-title" @click="toggleDisplayAddFaq()">FAQ</h2>
        </div>

        <div v-if="flagDisplayAddFaq" class="block-content">
          <h3 class="h4 font-w600  push">{{labelText010[actualLanguage]}}</h3>
          <div class="row">
            <div class="col-xs-12">
  
              <div v-for="(faqItem,index1) in faqItems" class="col-xs-12">
                  <h3 class="h3 font-w600 push-30-t push">{{faqItem.subjectTitle[actualLanguage]}}</h3>
                  <div v-bind:id="faqId[index1]" class="panel-group">

                    <div v-for="(faqIssue,index2) in faqItem.issues" class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title">
                                <a class="accordion-toggle" data-toggle="collapse" v-bind:data-parent="faqIdTag[index1]" v-bind:href=faqSubIdTag[index1][index2]>{{faqIssue.issueTitle[actualLanguage]}}</a>
                            </h3>
                        </div>
                        <div v-bind:id="faqSubId[index1][index2]" class="panel-collapse collapse">
                            <div class="panel-body">
                                <p>{{faqIssue.issueSolution[actualLanguage]}}</p>
                            </div>
                        </div>
                    </div>

                  </div>
              </div>

            </div>
                
          </div>
        </div>
      </div>
    <!-- FAQ Dynamique -->
    </div>

    
    <h3 class="h4 font-w600 push-50-t push">{{labelText02[actualLanguage]}}</h3>

    <div class="form-group">
        <div class="col-xs-12 col-sm-6 col-sm-offset-3">
            <button @click="showModal('transmit-help-request-form')" class="btn btn-block btn-success" type="submit"><i class="fa fa-envelope"></i> {{labelButtonSendMessage[actualLanguage]}}</button>
        </div>
    </div>


  </div>

</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'GroupIndex',
  data() {
    return {
      flagDisplayAddFaq : 0,

      labelButtonConfigurationDocumentation: {FR: 'Instructions de configuration', EN: 'Configuration instruction'},
      labelButtonUserGuideDocumentation: {FR: 'Guide utilisateur (Usagers)', EN: 'User guide (End user)'},
      labelButtonElectricalMeasurementDocumentation: {FR: 'Mesures électriques (tutoriel)', EN: 'Electrical measurement tutorial'},

      DocumentTableTitle : {FR: 'Documentation', EN: 'Documentation'},
      DocumentTableDetail : {FR: "Liste des documents disponibles. Si vous ne trouvez pas l'information recherchée, merci de nous transmettre votre demande en utilisant le bouton Demande d'assistance.",
                               EN: 'This is the list of available documents. If you do not find information you are looking for, please send us a request by using the Transmit support request button.'},

      DocumentListIsReading : false,
      DocumentTableContain:[],


      labelText01: {FR: "Consultez notre FAQ, vous pourriez y trouviez votre réponse! ", EN: 'Please check our FAQ, you may found your answer!'},
      labelText010: {FR: "Si un des sujets correspond à votre situation, vous n'avez qu'à cliquez sur le sujet correspondant pour voir la solution proposée.", EN: 'If one subject corresponds to your question, click on it to see the proposed solution.'},
      
      labelText02: {FR: "Vous n'avez pas trouver votre réponse? Transmettez-nous votre demande d'assistance:", EN: 'You did not found your answer? Please send us your support request:'},
      labelButtonSendMessage: {FR: "Demande d'assistance", EN: 'Transmit support request'},

      readEventLogDataModel: {
        profileid: '',
        startDate: '2020-01-01',
      },
      eventLogData : [],
      actualLanguage : 'FR',

      faqItems : [],
      faqId : [],
      faqIdTag : [],

      faqSubId : [],
      faqSubIdTag : [],

    }
  },
  components: {
    Spinner,

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayAddFaq(){
      this.flagDisplayAddFaq = ~this.flagDisplayAddFaq
    },


   toggleDisplayReadEventLog(){
      this.flagDisplayReadEventLog = ~this.flagDisplayReadEventLog
    },


    openConfigurationProcedure() {
      var localUrl ='';
      if (this.actualLanguage == 'FR'){
        localUrl =process.env.VAR_CONFIGURATION_INSTRUCTION_LINK_FR;
      }
      if (this.actualLanguage == 'EN'){
        localUrl =process.env.VAR_CONFIGURATION_INSTRUCTION_LINK_EN;
      }      

      window.open(localUrl, '_blank');  
    },


    openDocumentInTable(FileLink) {
      var localUrl ='';
      window.open(FileLink, '_blank');  
    },


    openUserGuide() {
      var localUrl ='';
      if (this.actualLanguage == 'FR'){
        localUrl =process.env.VAR_USERGUIDE_LINK_FR;
      }
      if (this.actualLanguage == 'EN'){
        localUrl =process.env.VAR_USERGUIDE_LINK_EN;
      }      

      window.open(localUrl, '_blank');  
    },





    openElectricalMeasurementGuide() {
      var localUrl ='';
      if (this.actualLanguage == 'FR'){
        localUrl =process.env.VAR_ELECTRICAL_MEASUREMENT_LINK_FR;
      }
      if (this.actualLanguage == 'EN'){
        localUrl =process.env.VAR_ELECTRICAL_MEASUREMENT_LINK_EN;
      }      

      window.open(localUrl, '_blank');  
    },


    getUserEventLogs() {
        this.eventLogData = [];
        return this.$store.dispatch('sessionStore/getEventsLog',this.readEventLogDataModel)
        .then((response) => {
          this.eventLogData = response.data.eventLogData.reverse()
          })
    },


    reloadPage(){
      window.location.reload()
    },
 
  getListHelpDocuments(){
      var requestData = { 'postAction':'GetHelpDocumentList',
                          'helpListVersion':'V1P00'}
      this.DocumentListIsReading = true
      this.$store.dispatch('sessionStore/postSupport', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
                  this.DocumentTableContain = response.data.Documents
                  this.DocumentListIsReading = false
              }
              else
              {
                window.alert(response.data.PromptMessage[this.actualLanguage])
              }
          })
    },


    getFaqItems(){
      var requestData = { 'postAction':'GetAllItemOver0',
                          'partitionKey': process.env.VAR_FAQ_LIST}
      this.$store.dispatch('sessionStore/postFrontEndTemplates', requestData)
          .then((response) => {
            //console.log(response.data)
          if(response.data.Code=='OK'){
                this.faqItems = response.data.TemplateItems
                this.faqId = []
                this.faqIdTag = []
                this.faqSubId = []
                this.faqSubIdTag = []

                var mm = 0
                var faqSubIdTempo = []
                var faqSubIdTagTempo = []
                for(var m=0;m<response.data.TemplateItems.length;m++){
                  this.faqId.push('faq'+m)
                  this.faqIdTag.push('#faq'+m)
                  faqSubIdTempo = []
                  faqSubIdTagTempo = []
                  for(mm=0;mm<response.data.TemplateItems[m].issues.length;mm++){
                    faqSubIdTempo.push('faq'+m+'_q'+mm)
                    faqSubIdTagTempo.push('#faq'+m+'_q'+mm)
                  }
                  this.faqSubId.push(faqSubIdTempo)
                  this.faqSubIdTag.push(faqSubIdTagTempo)
                }
              }
          })
    },



    },

    mounted() {
      //this.getDeviceData()
      //window.location.reload()
      //console.log("Profile");
      this.readEventLogDataModel.profileid = this.profileData.profileInfo.email;

      this.getFaqItems()
      this.getListHelpDocuments()

      if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
    }
}
</script>





// WEBPACK FOOTER //
// Index.vue?08f02036